import { StyleSheet, Platform } from 'react-native';
import { getResponsiveValue } from './breakpoints';
import { colors, typography, shadows, spacing, borderRadius } from './theme';
import { BREAKPOINTS } from './breakpoints';

export const myReportsStyles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: spacing.xl,
    paddingTop: spacing.lg,
    width: '100%',
    maxWidth: 1200,
    alignSelf: 'center',
  },
  title: {
    fontFamily: typography.primaryFont,
    fontSize: getResponsiveValue({
      mobile: 32,
      tablet: 36,
      laptop: 40,
      desktop: 44
    }),
    color: colors.textPrimary,
    textAlign: 'center',
    textShadow: shadows.text,
    marginBottom: spacing.xl,
  },
  loadingText: {
    fontFamily: typography.primaryFont,
    fontSize: 20,
    color: colors.textPrimary,
    textAlign: 'center',
  },
  emptyState: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.xl,
  },
  emptyStateText: {
    fontFamily: typography.primaryFont,
    fontSize: 18,
    color: colors.textSecondary,
    textAlign: 'center',
    marginBottom: spacing.lg,
  },
  submitButton: {
    backgroundColor: colors.primary,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.xl,
    borderRadius: borderRadius.md,
    marginTop: spacing.md,
  },
  submitButtonText: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textPrimary,
    textAlign: 'center',
  },
  reportsContainer: {
    flex: 1,
    width: '100%',
    zIndex: 2,
    position: 'relative'
  },
  reportCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: borderRadius.lg,
    marginBottom: spacing.lg,
    overflow: 'hidden',
    boxShadow: shadows.card,
    width: '100%',
    zIndex: 1
  },
  reportHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: spacing.md,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  venueName: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '700',
    fontSize: 20,
    color: colors.textPrimary,
    textShadow: shadows.text,
  },
  statusBadge: {
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    borderRadius: borderRadius.sm,
    minWidth: 80,
    alignItems: 'center',
  },
  statusApproved: {
    backgroundColor: colors.success,
  },
  statusRejected: {
    backgroundColor: colors.error,
  },
  statusPending: {
    backgroundColor: colors.warning,
  },
  statusText: {
    fontFamily: typography.primaryFont,
    fontSize: 12,
    color: colors.textPrimary,
    fontWeight: 'bold',
  },
  reportContent: {
    padding: spacing.md,
  },
  dateText: {
    fontFamily: typography.primaryFont,
    fontSize: 14,
    color: colors.textSecondary,
    marginBottom: spacing.md,
  },
  experienceLabel: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textPrimary,
    marginBottom: spacing.sm,
  },
  experienceText: {
    fontFamily: typography.primaryFont,
    fontSize: 14,
    color: colors.textSecondary,
    marginBottom: spacing.lg,
  },
  ratingsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.md,
    marginBottom: spacing.lg,
    padding: spacing.sm,
  },
  ratingItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: borderRadius.md,
    padding: spacing.md,
    minWidth: 150,
    boxShadow: shadows.card,
  },
  ratingLabel: {
    fontFamily: typography.primaryFont,
    fontSize: 14,
    color: colors.textSecondary,
    marginBottom: spacing.xs,
  },
  ratingInput: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderRadius: borderRadius.sm,
    padding: spacing.sm,
    color: colors.textPrimary,
    fontFamily: typography.primaryFont,
    fontSize: 18,
    textAlign: 'center',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.1)',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      ':focus': {
        borderColor: colors.accent,
        boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.1)',
      }
    }),
  },
  actionButton: {
    backgroundColor: '#666769',
    padding: 10,
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 120,
    [BREAKPOINTS.phone]: {
      width: '100%',
    },
  },
  actionButtonText: {
    color: '#ffffff',
    fontFamily: typography.primaryFont,
    fontSize: 16,
    fontWeight: 'bold',
    textShadow: shadows.text,
  },
  mediaSection: {
    marginTop: spacing.md,
    marginBottom: spacing.lg,
  },
  mediaButtons: {
    flexDirection: 'row',
    gap: spacing.md,
    marginBottom: spacing.md,
  },
  mediaPreviewTitle: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textPrimary,
    marginBottom: spacing.sm,
  },
  mediaPreviewScroll: {
    flexDirection: 'row',
    marginBottom: spacing.md,
  },
  mediaPreviewWrapper: {
    position: 'relative',
    marginRight: spacing.sm,
    ...(Platform.OS === 'web' && {
      transition: 'all 0.2s ease-in-out',
      ':hover': {
        transform: 'scale(1.05)',
      },
    }),
  },
  mediaPreview: {
    width: 120,
    height: 120,
    borderRadius: borderRadius.sm,
    marginRight: spacing.sm,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  removeMediaButton: {
    position: 'absolute',
    top: -8,
    right: -8,
    backgroundColor: colors.error,
    width: 24,
    height: 24,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: shadows.button,
    cursor: 'pointer',
    ...(Platform.OS === 'web' && {
      transition: 'all 0.2s ease-in-out',
      ':hover': {
        backgroundColor: colors.error + 'dd',
        transform: 'scale(1.1)',
      },
    }),
  },
  removeMediaButtonText: {
    color: colors.textPrimary,
    fontSize: 12,
    fontWeight: 'bold',
  },
  fileInput: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: borderRadius.sm,
    padding: spacing.sm,
    color: colors.textPrimary,
    width: '100%',
    marginBottom: spacing.sm,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      ':disabled': {
        cursor: 'not-allowed',
        opacity: 0.5,
      }
    }),
  },
  editButtonContainer: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: spacing.xl,
    paddingBottom: spacing.md,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255, 255, 255, 0.1)',
    marginTop: spacing.xl,
    flexDirection: getResponsiveValue({
      mobile: 'column',
      tablet: 'row',
      laptop: 'row',
      desktop: 'row'
    }),
    gap: spacing.md,
  },
  editButton: {
    backgroundColor: colors.accent,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.xl,
    borderRadius: borderRadius.md,
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: 180,
      laptop: 180,
      desktop: 180
    }),
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: shadows.button,
    transition: 'all 0.2s ease-in-out',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      ':hover': {
        transform: 'translateY(-1px)',
        boxShadow: shadows.buttonHover,
        backgroundColor: colors.accentHover,
      }
    }),
  },
  editButtonText: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textPrimary,
    fontWeight: 'bold',
    textShadow: shadows.text,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  editForm: {
    padding: spacing.lg,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: borderRadius.md,
    margin: spacing.md,
    boxShadow: shadows.card,
  },
  editInput: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: borderRadius.sm,
    padding: spacing.md,
    color: colors.textPrimary,
    marginBottom: spacing.md,
    minHeight: 100,
    fontFamily: typography.primaryFont,
    fontSize: 16,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.1)',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      ':focus': {
        borderColor: colors.accent,
        boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.1)',
      }
    }),
  },
  editActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: spacing.md,
    marginTop: spacing.lg,
    paddingTop: spacing.md,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255, 255, 255, 0.1)',
  },
  saveButton: {
    backgroundColor: 'black',
  },
  cancelButton: {
    backgroundColor: colors.error,
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  sectionTitle: {
    fontFamily: typography.primaryFont,
    fontSize: 20,
    color: colors.textPrimary,
    marginBottom: spacing.md,
    marginTop: spacing.lg,
    textShadow: shadows.text,
    fontWeight: 'bold',
    ...(Platform.OS === 'web' && {
      transition: 'opacity 0.3s ease, transform 0.3s ease',
    }),
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    marginTop: 10,
    [BREAKPOINTS.phone]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  revokeButton: {
    backgroundColor: colors.error,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.xl,
    borderRadius: borderRadius.md,
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: 180,
      laptop: 180,
      desktop: 180
    }),
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: shadows.button,
    transition: 'all 0.2s ease-in-out',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      ':hover': {
        transform: 'translateY(-1px)',
        boxShadow: shadows.buttonHover,
        backgroundColor: colors.errorHover,
      }
    }),
  },
  revokeButtonText: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textPrimary,
    fontWeight: 'bold',
    textShadow: shadows.text,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  technicalDetailsGrid: {
    gap: spacing.md,
    marginBottom: spacing.lg,
  },
  technicalDetailItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: borderRadius.md,
    padding: spacing.md,
    marginBottom: spacing.sm,
  },
  detailLabel: {
    fontFamily: typography.primaryFont,
    fontSize: 14,
    color: colors.textSecondary,
    marginBottom: spacing.xs,
  },
  detailInput: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderRadius: borderRadius.sm,
    padding: spacing.sm,
    color: colors.textPrimary,
    fontFamily: typography.primaryFont,
    fontSize: 16,
    minHeight: 40,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.1)',
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      ':focus': {
        borderColor: colors.accent,
        boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.1)',
      }
    }),
  },
  mediaPreviewGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    marginTop: spacing.sm,
  },
  mediaPreviewContainer: {
    position: 'relative',
  },
  mediaLabel: {
    fontFamily: typography.primaryFont,
    fontSize: 16,
    color: colors.textPrimary,
    marginBottom: spacing.sm,
  },
  mediaScroll: {
    flexDirection: 'row',
    marginBottom: spacing.md,
  },
  mediaUploadContainer: {
    marginBottom: spacing.md,
  },
  mediaUploadText: {
    color: colors.textPrimary,
    fontFamily: typography.primaryFont,
    fontSize: 14,
    marginBottom: spacing.xs,
  },
  techSpecsSection: {
    marginTop: 20,
    padding: 15,
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: 10,
  },
  techSpecsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: 15,
    marginTop: 10,
  },
  techSpecItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    padding: 10,
    borderRadius: 5,
  },
  techSpecLabel: {
    color: colors.textSecondary,
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
    marginBottom: 5,
  },
  techSpecValue: {
    color: colors.textPrimary,
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
  },
  techSpecsEditSection: {
    marginTop: 20,
    marginBottom: 20,
  },
  formGroup: {
    marginBottom: 15,
  },
  label: {
    color: colors.textPrimary,
    fontSize: 14,
    fontFamily: 'VastagoGrotesk',
    marginBottom: 5,
  },
  input: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 5,
    padding: 10,
    color: colors.textPrimary,
    fontFamily: 'VastagoGrotesk',
    fontSize: 14,
  },
  textArea: {
    minHeight: 100,
    textAlignVertical: 'top',
  },
}); 